// Base contact types from service
import { BaseResponse, BaseLightResponse, BaseLightResponseWrapper } from './common';

export interface ContactsResponse extends BaseResponse<ContactDoc> {}

// Light response for contacts with nested data structure
export interface ContactsLightResponse extends BaseLightResponseWrapper<ContactLightDoc> {}

// Individual contact light document
export interface ContactLightDoc extends BaseLightResponse {
  firstName: string;
  lastName: string;
  email: string;
  position?: string;
  phoneNumber?: string;
  status: string;
}

export interface ContactResponse {
  data: ContactData;
}

export interface ContactData {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  position: string;
  boss: null;
  type: any[];
  country: string;
  organization: string;
  lifeCycle: string;
  phoneNumber: string;
  status: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface ContactDoc {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  position?: string;
  type: Segment[];
  country: Country;
  organization: Organization;
  phoneNumber?: string;
  status: Status;
  createdAt: Date;
  updatedAt: Date;
  userExists: boolean;
  boss?: Boss;
}

export interface Boss {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface Country {
  _id: CountryID;
  name: CountryName;
  flag_image: FlagImage;
}

export enum CountryID {
  The650Db4Ed7392F865318E1Bac = '650db4ed7392f865318e1bac',
  The650Db4Fd7392F865318E1Bb2 = '650db4fd7392f865318e1bb2',
  The650Db5097392F865318E1Bbd = '650db5097392f865318e1bbd',
  The650Db5157392F865318E1Bc3 = '650db5157392f865318e1bc3',
  The650Db51F7392F865318E1Bc9 = '650db51f7392f865318e1bc9',
  The659D4Dc53F59E9D57635Bd3D = '659d4dc53f59e9d57635bd3d',
  The659D4E833F59E9D57635Bd4D = '659d4e833f59e9d57635bd4d',
}

export enum FlagImage {
  Ar = 'ar',
  Br = 'br',
  Cl = 'cl',
  Co = 'co',
  Ec = 'ec',
  MX = 'mx',
  PE = 'pe',
}

export enum CountryName {
  Argentina = 'Argentina',
  Brasil = 'Brasil',
  Chile = 'Chile',
  Colombia = 'Colombia',
  Ecuador = 'Ecuador',
  México = 'México',
  Perú = 'Perú',
}

export interface Organization {
  _id: string;
  name: string;
  owner: Owner;
  segment?: Segment;
}

export enum Owner {
  The6501F03Fb61F779B82B11A80 = '6501f03fb61f779b82b11a80',
  The651Ad2A81A1565D5A391D142 = '651ad2a81a1565d5a391d142',
  The6526Cf1644Ad73B9Cedddfc5 = '6526cf1644ad73b9cedddfc5',
  The6526Cf8144Ad73B9Cedde0D2 = '6526cf8144ad73b9cedde0d2',
  The6526Dfbc13120D8121Efeacd = '6526dfbc13120d8121efeacd',
  The6526F708Fef6B65014F0D165 = '6526f708fef6b65014f0d165',
  The65A029E95D36Ad13F72F8D41 = '65a029e95d36ad13f72f8d41',
  The65A538980C9A592Eb6B15E1A = '65a538980c9a592eb6b15e1a',
  The65A6D1721Ede2Cab5Bb5Dbb3 = '65a6d1721ede2cab5bb5dbb3',
  The65C2748B35Fcdf35A6C73Cc0 = '65c2748b35fcdf35a6c73cc0',
  The65C2940C093F70F4E9C7Ff0E = '65c2940c093f70f4e9c7ff0e',
  The67Aa4215B0Dfe6676F0Dd1F6 = '67aa4215b0dfe6676f0dd1f6',
  The67F0298Ec6Da784Ec7C0729E = '67f0298ec6da784ec7c0729e',
  The67F9Dd8A6Fbd863C0Bfadb11 = '67f9dd8a6fbd863c0bfadb11',
  The684C9945080D5Bb6078C1689 = '684c9945080d5bb6078c1689',
  The6862F3A7932D7Ea4950C91Fd = '6862f3a7932d7ea4950c91fd',
}

export interface Segment {
  _id: SegmentID;
  name: SegmentName;
}

export enum SegmentID {
  The650Db5387392F865318E1Bd7 = '650db5387392f865318e1bd7',
  The650Db5407392F865318E1Be1 = '650db5407392f865318e1be1',
  The650Db5487392F865318E1Bef = '650db5487392f865318e1bef',
  The65A8117362A93Dedeaca53B8 = '65a8117362a93dedeaca53b8',
  The65E096A2A7C5696F32C1B66F = '65e096a2a7c5696f32c1b66f',
  The65E096A2A7C5696F32C1B670 = '65e096a2a7c5696f32c1b670',
  The65E096A2A7C5696F32C1B672 = '65e096a2a7c5696f32c1b672',
  The65E096A2A7C5696F32C1B673 = '65e096a2a7c5696f32c1b673',
  The65E096A2A7C5696F32C1B674 = '65e096a2a7c5696f32c1b674',
  The686C375C1202F0Bcfbcc516D = '686c375c1202f0bcfbcc516d',
}

export enum SegmentName {
  Administrativo = 'Administrativo',
  CLevel = 'C-level',
  Comercial = 'Comercial',
  Corporate = 'Corporate',
  Encuesta = 'Encuesta',
  Enterprise = 'Enterprise',
  Marketplace = 'Marketplace',
  Operativo = 'Operativo',
  SMB = 'SMB',
  TopSMB = 'Top SMB',
}

export enum Status {
  Active = 'active',
}

// Legacy types for backward compatibility
export type IContactItem = ContactData & {
  typeContact: any[];
  isActive: boolean;
  priority: string;
  notes: string;
};

export type IContactTableFilterValue = string | string[];

export type IContactTableFilters = {
  search: string;
  countries: any[];
  lifeCycles: any[];
  status: any[];
  segments: string[];
  page: number;
  pageSize: number;
};

export enum ContactStatus {
  active = 'active',
  pending = 'pending',
  unlinked = 'unlinked',
  suspended = 'suspended',
  deleted = 'deleted',
}
